import { Button, ConfigProvider, Modal, Segmented } from 'antd';
import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { engageAgent } from '../../../../../../reduxToolkit/inboxSlice';
import TeamMemberList from './TeamMemberList';
import ButtonGX from '../../../../../channels/page/webChat/ButtonGX';
import {
  showErrorToast,
  showSuccessToast,
} from '../../../../../../components/commonComponents/gxAntdToast/toastUtils';
import NotificationContext from '../../../../../../providers/NotificationProvider';

const AgentEngagement = ({ isTeamLead, agent_engagement_status }) => {
  // hooks
  const dispatch = useDispatch();
  const toast = useContext(NotificationContext);
  // selectors
  const { currentBrand } = useSelector((state) => state?.app);
  const {
    selectedWebChatTeam,
    selectedWebChatConversation,
    agentEngagementLoading,
  } = useSelector((state) => state?.inbox);

  // states
  const [open, setOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  // handlers
  const handleAgentEngagement = async (e) => {
    const params = {
      brand_id: currentBrand?.brand_id,
      team_id: selectedWebChatTeam?.team_id,
      conversation_id: selectedWebChatConversation?.id,
      agent_engagement_status: e,
    };
    if (!e) params.team_member_id = selectedMember;
    const res = await dispatch(engageAgent(params));
    console.log({ res });
    if (
      res?.type === 'inbox/web_chat/engageAgent/fulfilled' &&
      agent_engagement_status
    ) {
      showSuccessToast(toast, 'Conversation engaged successfully', 2);
    } else if (res?.type === 'inbox/web_chat/engageAgent/rejected') {
      showErrorToast(toast, 'Conversation engaged failed', 2);
    }
  };

  const handleAssignConversation = () => {
    if (agent_engagement_status) {
      setOpen(true);
    } else {
      handleAgentEngagement(true);
    }
  };

  // const handleMemberSelect = (member_id) => {
  //   setSelectedMember(member_id);
  //   // handleAgentEngagement(member_id);
  // };
  return (
    <div>
      {/*
      <Switch
        disabled={!isTeamLead}
        loading={agentEngagementLoading}
        checkedChildren="Agent Engage"
        unCheckedChildren="User Engage"
        onChange={handleAgentEngagement}
        value={agent_engagement_status}
      />
      */}

      <Modal
        open={open}
        title="Assign this conversation to:"
        centered
        onCancel={() => {
          setOpen(false);
          setSelectedMember(null);
        }}
        footer={
          <ButtonGX
            disabled={!selectedMember}
            loading={agentEngagementLoading}
            onClick={() => {
              handleAgentEngagement(!agent_engagement_status);
              setOpen(false);
              setSelectedMember(null);
            }}
          >
            Assign
          </ButtonGX>
        }
      >
        <TeamMemberList
          handleMemberSelect={setSelectedMember}
          selectedMember={selectedMember}
        />
      </Modal>
      <ConfigProvider
        theme={{
          components: {
            Segmented: {
              itemSelectedBg: '#87d068',
              itemSelectedColor: '#fff',
            },
          },
        }}
      >
        <Segmented
          disabled={!isTeamLead || agentEngagementLoading}
          options={[
            { label: 'USER', value: false },
            { label: 'AI AGENT', value: true },
          ]}
          value={agent_engagement_status}
          onChange={handleAssignConversation}
        />
      </ConfigProvider>
    </div>
  );
};

export default AgentEngagement;
